import styled from 'styled-components';
import { NewsFeedItemLink } from './NewsFeedItemLink';

export const NewsFeedItemTitle = styled.div`
  margin-bottom: 4px;
  line-height: 1.3;
  word-break: break-all;

  ${NewsFeedItemLink}:hover & {
    color: ${({ theme }) => theme.news.palette.link_hover_pc};
    text-decoration: underline;
  }

  ${NewsFeedItemLink}:visited & {
    color: ${({ theme }) => theme.news.palette.link_visited_pc};
  }
`;
